import { MatchDetail, RootState, Status } from '../types';

export const getMatchDetailStatus = (state: RootState): Status => state.matchDetail.status;

export const getMatchDetailErrorMsg = (state: RootState): string | null =>
  state.matchDetail.errorMsg;

export const getMatchDetail = (state: RootState): MatchDetail | null =>
  state.matchDetail.matchDetail;
